import { AvailableOption, Partner } from 'app/api/@generated/backend';

import { EcomAdditionalDataLayerEventType, EcomDataLayerEventType } from 'app/data-layers/model/data-layer-event-types';
import { DataLayerUtils } from 'app/data-layers/utils/data-layer-utils';
import { i18n } from 'app/i18n';
import { DataLayerEcomItem } from 'app/data-layers/model/data-layer-event';

import { pushFunnelEventStep } from './push-funnel-event-step';

export const pushShippingInfoEvent = (
    items: DataLayerEcomItem[],
    selectedWifiOption: AvailableOption,
    isHomeGatewayUpgradeRequired: boolean,
    selectionType: string,
    partner?: Partner,
) => {
    pushFunnelEventStep(EcomDataLayerEventType.ADD_SHIPPING_INFO, partner, items);

    DataLayerUtils.pushEcomEventToDataLayer({
        event: EcomDataLayerEventType.ADD_SHIPPING_INFO,
        selection_type: selectionType,
        ecommerce: {
            shipping_tier: isHomeGatewayUpgradeRequired
                ? i18n.product.delivery.technician
                : i18n.product.delivery.transporter,
            value: selectedWifiOption.totalFirstYearPrice,
            currency: selectedWifiOption.recurringCharge.currency,
            items,
        },
    });

    DataLayerUtils.pushEcomEventToDataLayer({
        event: EcomAdditionalDataLayerEventType.ADD_PAYMENT_INFO,
        selection_type: selectionType,
        ecommerce: {
            payment_type: i18n.product.paymentType,
            value: selectedWifiOption.totalFirstYearPrice,
            currency: selectedWifiOption.recurringCharge.currency,
            items,
        },
    });
};
